import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { ContentProvider } from './ContentProvider';
import { Loading } from '@/components/partials/loader/Loading';
import { NativeNagivator } from '@/components/utility/NativeNagivator';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<NativeNagivator />
				<MantineProvider>
					<QueryProvider>
						<AuthProvider>
							<ContentProvider>
								<Suspense fallback={<Loading fullHeight />}>
									{children}
								</Suspense>
							</ContentProvider>
						</AuthProvider>
					</QueryProvider>
				</MantineProvider>
			</BrowserRouter>
		</Provider>
	);
};
